var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-faq"},[_c('VueFaqAccordion',{staticClass:"text-base",attrs:{"items":_vm.myItems,"activeColor":"#006400","fontColor":"#000","borderColor":"#006400"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }